/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1SerieQueryResponse,
  GetApiV1SerieQueryParams,
  GetApiV1Serie401,
  GetApiV1Serie500,
} from "../../types/serieRegistroController/GetApiV1Serie.ts";

function getGetApiV1SerieUrl() {
  const res = { method: "GET", url: `/api/v1/serie` as const };
  return res;
}

/**
 * @description Retorna uma lista paginada de séries. Filtra por tipo (Principal/Empresa/Todos) e por título. Usuários vinculados a uma empresa veem apenas as séries da própria empresa. **(Requer Authorization para autenticação)**
 * @summary Listar séries (Requer Authorization para autenticação)
 * {@link /api/v1/serie}
 */
export async function getApiV1Serie(
  params?: GetApiV1SerieQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1SerieQueryResponse,
    ResponseErrorConfig<GetApiV1Serie401 | GetApiV1Serie500>,
    unknown
  >({
    method: "GET",
    url: getGetApiV1SerieUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
